module.exports = __webpack_public_path__ + "img/dsci0010.5d3d00ed.jpg";